import { createComponent } from '@carvana/merch-components';

export const Wrapper = createComponent('div', {
  className: 'mx-auto flex w-full max-w-[960px] flex-col gap-y-xl px-2xl py-4xl'
});

export const Title = createComponent('h1', { className: 't-heading-xl' });

export const EffectiveDate = createComponent('p', {
  className: 't-body-md text-text-secondary'
});

export const Table = createComponent('table', {
  className: 'w-full border-collapse'
});

export const TableCell = createComponent('td', {
  className: 'border border-border-default p-sm'
});

export const TableHeaderCell = createComponent('td', {
  className: 'border border-border-default p-sm t-heading-xs'
});
